// if sunroof cleaning, handle that before covered repair, return
// •	This benefit will be made available to Settlement Class Members
//  for a period of 9-years or 90,000-miles from the Settlement Class 
// Vehicle’s In-Service Date, whichever occurs first.

function normalizeMiles(miles) {
    if (typeof miles === "number") {
        return miles;
    }

    if (typeof miles === "string") {
        const normalized = miles.replace(/,/g, "").trim();
        const parsed = Number(normalized);
        return Number.isFinite(parsed) ? parsed : NaN;
    }

    return NaN;
}

function isValidDate(date) {
    return date instanceof Date && !Number.isNaN(date.getTime());
}

class WarrantyCleaning {
    constructor(inServiceDate, todaysDate, miles) {
        this.inServiceDate = new Date(inServiceDate);
        this.todaysDate = new Date(todaysDate);
        this.miles = miles;
    }

    calculator() {
        const warrantyPeriodInYears = 9;
        const maxMiles = 90000;

        const serviceDate = this.inServiceDate;
        const currentDate = this.todaysDate;
        const miles = normalizeMiles(this.miles);

        if (!isValidDate(serviceDate) || !isValidDate(currentDate)) {
            return {
                warrantyStatus: "Expired",
                warrantyPercentage: 0
            };
        }

        if (!Number.isFinite(miles) || miles < 0) {
            return {
                warrantyStatus: "Expired",
                warrantyPercentage: 0
            };
        }

        if (currentDate < serviceDate) {
            return {
                warrantyStatus: "Expired",
                warrantyPercentage: 0
            };
        }

        const expirationDate = new Date(serviceDate);
        expirationDate.setUTCFullYear(
            serviceDate.getUTCFullYear() + warrantyPeriodInYears
        );

        if (miles >= maxMiles || currentDate >= expirationDate) {
            return {
                warrantyStatus: "Expired",
                warrantyPercentage: 0
            };
        }

        return {
            warrantyStatus: "Valid",
            warrantyPercentage: 100
        };
    }
}

export default WarrantyCleaning;
